export default __webpack_public_path__ + "static/media/finance.e2d3a44f.png";